import _ from "lodash";

export const roundAmount = (amount, currencyConfig, keepDecimalZeros = true) =>
	keepDecimalZeros
		? +amount.toFixed(currencyConfig?.rounding || 2)
		: `${parseFloat(amount.toFixed(currencyConfig?.rounding || 2))}`;

export const formatMoneyAmount = (amount, config, currencyConfig, returnOnlyAmount = false) => {
	if (_.isNil(amount)) return null;

	let roundedAmount = roundAmount(amount, currencyConfig);

	if (returnOnlyAmount) return roundedAmount;

	roundedAmount = roundedAmount.toLocaleString();

	const currencyName = currencyConfig?.name || "";

	if (config.useCurrencySymbol)
		return `${currencyName ? config.currencySymbol[currencyName] : ""} ${roundedAmount}`;

	return `${roundedAmount} ${currencyName}`;
};
